import { api } from '../api';

// One turn of the Snapfy Assistant conversation. The chat is stateless on the
// backend: the full history is sent every turn (same shape as the workflow agent).
export interface AssistantTurn {
  role: 'user' | 'assistant';
  text: string;
}

export interface AssistantRecommendation {
  app: string;
  route: string;
  label: string;
}

export interface AssistantResponse {
  reply: string;
  action: 'chat' | 'navigate' | 'build_workflow';
  // Present when the assistant points the user at a specific Snapfy app.
  recommendation: AssistantRecommendation | null;
  // Present when action === 'build_workflow': the brief used to seed the Workflow agent.
  workflowSeed: string | null;
}

export const assistantService = {
  // Calls the Laravel endpoint that runs the LLM server-side (the front NEVER
  // talks to an AI SDK). Returns the assistant reply + optional app recommendation.
  async chat(history: AssistantTurn[], message: string): Promise<AssistantResponse> {
    const res = await api.post('/assistant/chat', { history, message });
    return (res.data as { data: AssistantResponse }).data;
  },
};
